//FIRST PRODUCT OPTION
document.addEventListener("DOMContentLoaded", function () {
    let isSubscribed = true;
    let selectedRadioValue = null;

    function updateCancelAnytimeSection() {
        const cancelAnytimeSections = document.querySelectorAll(".cancel-anytime");
        
        cancelAnytimeSections.forEach((section) => {
            const cancelText = section.querySelector(".cancel-text");
            const figure = section.querySelector("figure");
            
            if (!isSubscribed) {

                if (cancelText) {
                    cancelText.style.display = "none";
                }
                section.classList.remove("justify-between");
                section.classList.add("justify-center");
                if (figure) {
                    figure.style.margin = "0 auto";
                }
            } else {
            
                if (cancelText) {
                    cancelText.style.display = "inline";
                }
                section.classList.remove("justify-center");
                section.classList.add("justify-between");
                if (figure) {
                    figure.style.margin = "";
                }
            }
        });
    }

    document.querySelectorAll(".toggle-section").forEach((section) => {
        const toggleBg = section.querySelector(".toggle-bg");
        const subscribeOption = section.querySelector(".subscribe-option");
        const oneTimeOption = section.querySelector(".one-time-option");
        const subscribeList = section.querySelector(".subscribeList");
        const itemRadios = section.querySelectorAll(".item-select-radio");
        const buyNowButton = section.querySelector(".buy-now-btn");
        const optionContainers = section.querySelectorAll(".option-container");
        
        const style = document.createElement('style');
        style.textContent = `
            .option-container {
                border-top: 2px solid transparent !important;
                border-left: 2px solid transparent !important;
                border-right: 2px solid transparent !important;
                border-bottom: 2px solid #66666666 !important;
                transition: all 0.2s ease;
            }
            /* Remove bottom border from last child */
            .option-container:last-child {
                border-bottom: 2px solid transparent !important;
            }
            .option-container.selected-option {
                border-bottom: 2px solid #CC1300 !important;
                border-top-color: #CC1300 !important;
                border-left-color: #CC1300 !important;
                border-right-color: #CC1300 !important;
                border-bottom-color: #CC1300 !important;
            }
            /* If last child is selected, still show red border */
            .option-container:last-child.selected-option {
                border-bottom: 2px solid #CC1300 !important;
            }
        `;
        document.head.appendChild(style);

        function updateSelection(selected) {
            isSubscribed = selected === "subscribe";

            document.querySelectorAll(".toggle-section").forEach((sec) => {
                const secToggleBg = sec.querySelector(".toggle-bg");
                const secSubscribeOption = sec.querySelector(".subscribe-option");
                const secOneTimeOption = sec.querySelector(".one-time-option");
                const secSubscribeSpans = sec.querySelectorAll(".subscribe");

                const subscribeWidth = secSubscribeOption.offsetWidth;
                const oneTimeWidth = secOneTimeOption.offsetWidth;

                if (isSubscribed) {
                    secToggleBg.style.width = `${subscribeWidth}px`;
                    secToggleBg.style.transform = "translateX(0)";
                    secSubscribeOption.querySelector("span").classList.add("text-white");
                    secSubscribeOption.querySelector("span").classList.remove("text-[#2D433D]");
                    secOneTimeOption.querySelector("span").classList.add("text-[#2D433D]");
                    secOneTimeOption.querySelector("span").classList.remove("text-white");

                    if (secSubscribeOption.querySelector(".subscribe-text")) {
                        secSubscribeOption.querySelector(".subscribe-text").style.fontWeight = "500";
                    }
                    if (secOneTimeOption.querySelector(".one-time-text")) {
                        secOneTimeOption.querySelector(".one-time-text").style.fontWeight = "600";
                    }

                    secSubscribeSpans.forEach((span) => {
                        span.style.display = "inline";
                    });

                    updateAllPricesAndTexts(true); // true = update all prices
                } else {
                    secToggleBg.style.width = `${oneTimeWidth}px`;
                    secToggleBg.style.transform = `translateX(${subscribeWidth}px)`;
                    secOneTimeOption.querySelector("span").classList.add("text-white");
                    secOneTimeOption.querySelector("span").classList.remove("text-[#2D433D]");
                    secSubscribeOption.querySelector("span").classList.add("text-[#2D433D]");
                    secSubscribeOption.querySelector("span").classList.remove("text-white");

                    if (secSubscribeOption.querySelector(".subscribe-text")) {
                        secSubscribeOption.querySelector(".subscribe-text").style.fontWeight = "600";
                    }
                    if (secOneTimeOption.querySelector(".one-time-text")) {
                        secOneTimeOption.querySelector(".one-time-text").style.fontWeight = "500";
                    }

                    secSubscribeSpans.forEach((span) => {
                        span.style.display = "none";
                    });

                    updateAllPricesAndTexts(true); 
                }

                updateBuyNowLink();
                updateSelectedOption();
                updateCancelAnytimeSection(); 
            });
        }

        function updateAllPricesAndTexts(updateAllOptions = false) {
            const allPrices = document.querySelectorAll(".price");
            

            if (updateAllOptions) {
                if (isSubscribed) {
                
                    if (allPrices[0]) allPrices[0].textContent = "41.65";
                    if (allPrices[1]) allPrices[1].textContent = "50.15";
                    if (allPrices[2]) allPrices[2].textContent = "58.65";
                } else {
              
                    if (allPrices[0]) allPrices[0].textContent = "49";
                    if (allPrices[1]) allPrices[1].textContent = "59";
                    if (allPrices[2]) allPrices[2].textContent = "69";
                }
            } else {
           
                if (isSubscribed) {
                    switch (selectedRadioValue) {
                        case "1":
                            if (allPrices[0]) allPrices[0].textContent = "41.65";
                            break;
                        case "2":
                            if (allPrices[1]) allPrices[1].textContent = "50.15";
                            break;
                        case "3":
                            if (allPrices[2]) allPrices[2].textContent = "58.65";
                            break;
                    }
                } else {
                    switch (selectedRadioValue) {
                        case "1":
                            if (allPrices[0]) allPrices[0].textContent = "49";
                            break;
                        case "2":
                            if (allPrices[1]) allPrices[1].textContent = "59";
                            break;
                        case "3":
                            if (allPrices[2]) allPrices[2].textContent = "69";
                            break;
                    }
                }
            }
        
            updateTotalPrice();
            updateSavePrice();
        }

        function updateTotalPrice() {
            const strikePriceElement = document.querySelector(".strike-price");
            const strikethroughElement = document.querySelector(".strikethrough");
            
            if (strikePriceElement && strikethroughElement && selectedRadioValue) {
                if (isSubscribed) {
                    switch (selectedRadioValue) {
                        case "1":
                            strikePriceElement.textContent = "$249.90";
                            strikethroughElement.textContent = "$594";
                            break;
                        case "2":
                            strikePriceElement.textContent = "$150.45";
                            strikethroughElement.textContent = "$297";
                            break;
                        case "3":
                            strikePriceElement.textContent = "$63.60";
                            strikethroughElement.textContent = "$99";
                            break;
                        default:
                            strikePriceElement.textContent = "$249.90";
                            strikethroughElement.textContent = "$594";
                    }
                } else {
                    switch (selectedRadioValue) {
                        case "1":
                            strikePriceElement.textContent = "$294.00";
                            strikethroughElement.textContent = "$594";
                            break;
                        case "2":
                            strikePriceElement.textContent = "$177.00";
                            strikethroughElement.textContent = "$297";
                            break;
                        case "3":
                            strikePriceElement.textContent = "$73.95";
                            strikethroughElement.textContent = "$99";
                            break;
                        default:
                            strikePriceElement.textContent = "$294.00";
                            strikethroughElement.textContent = "$594";
                    }
                }
            }
        }

        function updateSavePrice() {
            const savePriceElement = document.querySelector(".save-price");
            
            if (savePriceElement && selectedRadioValue) {
                if (isSubscribed) {
                    switch (selectedRadioValue) {
                        case "1":
                            savePriceElement.textContent = "You Save $344.10";
                            break;
                        case "2":
                            savePriceElement.textContent = "You Save $146.55";
                            break;
                        case "3":
                            savePriceElement.textContent = "You Save $40.35";
                            break;
                        default:
                            savePriceElement.textContent = "You Save $344.10";
                    }
                } else {
                    switch (selectedRadioValue) {
                        case "1":
                            savePriceElement.textContent = "You Save $300.00";
                            break;
                        case "2":
                            savePriceElement.textContent = "You Save $120.00";
                            break;
                        case "3":
                            savePriceElement.textContent = "You Save $30.00";
                            break;
                        default:
                            savePriceElement.textContent = "You Save $300.00";
                    }
                }
            }
        }

        function updateBuyNowLink() {
            const buyNowLinks = document.querySelectorAll(".buy-now-link");
            const selectedRadio = document.querySelector(`.item-select-radio[value="${selectedRadioValue}"]`);

            if (selectedRadio) {
                const qparam = window.location.search.replace("?", "");
                let link = isSubscribed
                    ? selectedRadio.getAttribute("data-link-subscribe")
                    : selectedRadio.getAttribute("data-link-one-time");

                if (qparam && link) {
                    const existingParams = new URLSearchParams(qparam);
                    const url = new URL(link, window.location.origin);
                    link = url.origin + url.pathname + "?" + existingParams.toString() + (url.search ? "&" + url.searchParams.toString() : "");
                }

                buyNowLinks.forEach((buyNowLink) => {
                    if (buyNowLink && link) {
                        buyNowLink.href = link;
                    }
                });
            }
        }

        function updateSelectedOption() {
            document.querySelectorAll(".toggle-section").forEach((sec) => {
                const optionContainers = sec.querySelectorAll(".option-container");
                optionContainers.forEach((container) => {
                    const radioButton = container.querySelector(".item-select-radio");

                    if (radioButton && radioButton.value === selectedRadioValue) {
                        container.classList.add("selected-option");
                        radioButton.checked = true;
                    } else if (radioButton) {
                        container.classList.remove("selected-option");
                        radioButton.checked = false;
                    }
                });
            });
        }

        function preselectFirstOption() {
            document.querySelectorAll(".toggle-section").forEach((sec) => {
                const firstRadio = sec.querySelector(".item-select-radio");
                if (firstRadio) {
                    firstRadio.checked = true;
                    selectedRadioValue = firstRadio.value;
                    firstRadio.dispatchEvent(new Event("change"));
                }
            });
        }

        subscribeOption.addEventListener("click", () => updateSelection("subscribe"));
        oneTimeOption.addEventListener("click", () => updateSelection("one-time"));

        itemRadios.forEach((radio) => {
            radio.addEventListener("change", function () {
                selectedRadioValue = radio.value;
                updateAllPricesAndTexts(false); // false = update only selected
                updateBuyNowLink();
                updateSelectedOption();
            });
        });
        
        optionContainers.forEach((container) => {
            container.addEventListener("click", function () {
                const radioButton = container.querySelector(".item-select-radio");
                if (radioButton) {
                    radioButton.checked = true;
                    selectedRadioValue = radioButton.value;
                    radioButton.dispatchEvent(new Event("change"));
                }
            });
        });

        window.addEventListener("resize", () => updateSelection(isSubscribed ? "subscribe" : "one-time"));

        updateSelection("subscribe");
        preselectFirstOption();
    });

    updateCancelAnytimeSection();
});

// SECOND PRODUCT OPTION
document.addEventListener("DOMContentLoaded", function () {
    let isSubscribed2 = true;
    let selectedRadioValue2 = null;

    function updateCancelAnytimeSection2() {
        const cancelAnytimeSections = document.querySelectorAll(".cancel-anytime-2");
        
        cancelAnytimeSections.forEach((section) => {
            const cancelText = section.querySelector(".cancel-text-2");
            const figure = section.querySelector(".payment-type-2");
            
            if (!isSubscribed2) {
                if (cancelText) {
                    cancelText.style.display = "none";
                }
                section.classList.remove("justify-between");
                section.classList.add("justify-center");
                if (figure) {
                    figure.style.margin = "0 auto";
                }
            } else {
                if (cancelText) {
                    cancelText.style.display = "inline";
                }
                section.classList.remove("justify-center");
                section.classList.add("justify-between");
                if (figure) {
                    figure.style.margin = "";
                }
            }
        });
    }

    document.querySelectorAll(".toggle-section-2").forEach((section) => {
        const toggleBg = section.querySelector(".toggle-bg-2");
        const subscribeOption = section.querySelector(".subscribe-option-2");
        const oneTimeOption = section.querySelector(".one-time-option-2");
        const subscribeList = section.querySelector(".subscribeList-2");
        const itemRadios = section.querySelectorAll(".item-select-radio-2");
        const buyNowButton = section.querySelector(".buy-now-btn-2");
        const optionContainers = section.querySelectorAll(".option-container-2");
        
        const style = document.createElement('style');
        style.textContent = `
            .option-container-2 {
                border-top: 2px solid transparent !important;
                border-left: 2px solid transparent !important;
                border-right: 2px solid transparent !important;
                border-bottom: 2px solid #66666666 !important;
                transition: all 0.2s ease;
            }
            .option-container-2:last-child {
                border-bottom: 2px solid transparent !important;
            }
            .option-container-2.selected-option-2 {
                border-bottom: 2px solid #CC1300 !important;
                border-top-color: #CC1300 !important;
                border-left-color: #CC1300 !important;
                border-right-color: #CC1300 !important;
                border-bottom-color: #CC1300 !important;
            }
            .option-container-2:last-child.selected-option-2 {
                border-bottom: 2px solid #CC1300 !important;
            }
        `;
        document.head.appendChild(style);

        function updateSelection2(selected) {
            isSubscribed2 = selected === "subscribe";

            document.querySelectorAll(".toggle-section-2").forEach((sec) => {
                const secToggleBg = sec.querySelector(".toggle-bg-2");
                const secSubscribeOption = sec.querySelector(".subscribe-option-2");
                const secOneTimeOption = sec.querySelector(".one-time-option-2");
                const secSubscribeSpans = sec.querySelectorAll(".subscribe-2");

                const subscribeWidth = secSubscribeOption.offsetWidth;
                const oneTimeWidth = secOneTimeOption.offsetWidth;

                if (isSubscribed2) {
                    secToggleBg.style.width = `${subscribeWidth}px`;
                    secToggleBg.style.transform = "translateX(0)";
                    secSubscribeOption.querySelector("span").classList.add("text-white");
                    secSubscribeOption.querySelector("span").classList.remove("text-[#2D433D]");
                    secOneTimeOption.querySelector("span").classList.add("text-[#2D433D]");
                    secOneTimeOption.querySelector("span").classList.remove("text-white");

                    secSubscribeSpans.forEach((span) => {
                        span.style.display = "inline";
                    });

                    updateAllPricesAndTexts2(true);
                } else {
                    secToggleBg.style.width = `${oneTimeWidth}px`;
                    secToggleBg.style.transform = `translateX(${subscribeWidth}px)`;
                    secOneTimeOption.querySelector("span").classList.add("text-white");
                    secOneTimeOption.querySelector("span").classList.remove("text-[#2D433D]");
                    secSubscribeOption.querySelector("span").classList.add("text-[#2D433D]");
                    secSubscribeOption.querySelector("span").classList.remove("text-white");

                    secSubscribeSpans.forEach((span) => {
                        span.style.display = "none";
                    });

                    updateAllPricesAndTexts2(true);
                }

                updateBuyNowLink2();
                updateSelectedOption2();
                updateCancelAnytimeSection2();
            });
        }

        function updateAllPricesAndTexts2(updateAllOptions = false) {
            const allPrices = document.querySelectorAll(".price-2");
            
            if (updateAllOptions) {
                if (isSubscribed2) {
                    if (allPrices[0]) allPrices[0].textContent = "41.65";
                    if (allPrices[1]) allPrices[1].textContent = "50.15";
                    if (allPrices[2]) allPrices[2].textContent = "58.65";
                } else {
                    if (allPrices[0]) allPrices[0].textContent = "49";
                    if (allPrices[1]) allPrices[1].textContent = "59";
                    if (allPrices[2]) allPrices[2].textContent = "69";
                }
            } else {
                if (isSubscribed2) {
                    switch (selectedRadioValue2) {
                        case "1":
                            if (allPrices[0]) allPrices[0].textContent = "41.65";
                            break;
                        case "2":
                            if (allPrices[1]) allPrices[1].textContent = "50.15";
                            break;
                        case "3":
                            if (allPrices[2]) allPrices[2].textContent = "58.65";
                            break;
                    }
                } else {
                    switch (selectedRadioValue2) {
                        case "1":
                            if (allPrices[0]) allPrices[0].textContent = "49";
                            break;
                        case "2":
                            if (allPrices[1]) allPrices[1].textContent = "59";
                            break;
                        case "3":
                            if (allPrices[2]) allPrices[2].textContent = "69";
                            break;
                    }
                }
            }
        
            updateTotalPrice2();
            updateSavePrice2();
        }

        function updateTotalPrice2() {
            const strikePriceElement = document.querySelector(".strike-price-2");
            const strikethroughElement = document.querySelector(".strikethrough-2");
            
            if (strikePriceElement && strikethroughElement && selectedRadioValue2) {
                if (isSubscribed2) {
                    switch (selectedRadioValue2) {
                        case "1":
                            strikePriceElement.textContent = "$249.90";
                            strikethroughElement.textContent = "$594";
                            break;
                        case "2":
                            strikePriceElement.textContent = "$150.45";
                            strikethroughElement.textContent = "$297";
                            break;
                        case "3":
                            strikePriceElement.textContent = "$63.60";
                            strikethroughElement.textContent = "$99";
                            break;
                        default:
                            strikePriceElement.textContent = "$249.90";
                            strikethroughElement.textContent = "$594";
                    }
                } else {
                    switch (selectedRadioValue2) {
                        case "1":
                            strikePriceElement.textContent = "$294.00";
                            strikethroughElement.textContent = "$594";
                            break;
                        case "2":
                            strikePriceElement.textContent = "$177.00";
                            strikethroughElement.textContent = "$297";
                            break;
                        case "3":
                            strikePriceElement.textContent = "$73.95";
                            strikethroughElement.textContent = "$99";
                            break;
                        default:
                            strikePriceElement.textContent = "$294.00";
                            strikethroughElement.textContent = "$594";
                    }
                }
            }
        }

        function updateSavePrice2() {
            const savePriceElement = document.querySelector(".save-price-2");
            
            if (savePriceElement && selectedRadioValue2) {
                if (isSubscribed2) {
                    switch (selectedRadioValue2) {
                        case "1":
                            savePriceElement.textContent = "You Save $344.10";
                            break;
                        case "2":
                            savePriceElement.textContent = "You Save $146.55";
                            break;
                        case "3":
                            savePriceElement.textContent = "You Save $40.35";
                            break;
                        default:
                            savePriceElement.textContent = "You Save $344.10";
                    }
                } else {
                    switch (selectedRadioValue2) {
                        case "1":
                            savePriceElement.textContent = "You Save $300.00";
                            break;
                        case "2":
                            savePriceElement.textContent = "You Save $120.00";
                            break;
                        case "3":
                            savePriceElement.textContent = "You Save $30.00";
                            break;
                        default:
                            savePriceElement.textContent = "You Save $300.00";
                    }
                }
            }
        }

        function updateBuyNowLink2() {
            const buyNowLinks = document.querySelectorAll(".buy-now-link-2");
            const selectedRadio = document.querySelector(`.item-select-radio-2[value="${selectedRadioValue2}"]`);

            if (selectedRadio) {
                const qparam = window.location.search.replace("?", "");
                let link = isSubscribed2
                    ? selectedRadio.getAttribute("data-link-subscribe")
                    : selectedRadio.getAttribute("data-link-one-time");

                if (qparam && link) {
                    const existingParams = new URLSearchParams(qparam);
                    const url = new URL(link, window.location.origin);
                    link = url.origin + url.pathname + "?" + existingParams.toString() + (url.search ? "&" + url.searchParams.toString() : "");
                }

                buyNowLinks.forEach((buyNowLink) => {
                    if (buyNowLink && link) {
                        buyNowLink.href = link;
                    }
                });
            }
        }

        function updateSelectedOption2() {
            document.querySelectorAll(".toggle-section-2").forEach((sec) => {
                const optionContainers = sec.querySelectorAll(".option-container-2");
                optionContainers.forEach((container) => {
                    const radioButton = container.querySelector(".item-select-radio-2");

                    if (radioButton && radioButton.value === selectedRadioValue2) {
                        container.classList.add("selected-option-2");
                        radioButton.checked = true;
                    } else if (radioButton) {
                        container.classList.remove("selected-option-2");
                        radioButton.checked = false;
                    }
                });
            });
        }

        function preselectFirstOption2() {
            document.querySelectorAll(".toggle-section-2").forEach((sec) => {
                const firstRadio = sec.querySelector(".item-select-radio-2");
                if (firstRadio) {
                    firstRadio.checked = true;
                    selectedRadioValue2 = firstRadio.value;
                    firstRadio.dispatchEvent(new Event("change"));
                }
            });
        }

        subscribeOption.addEventListener("click", () => updateSelection2("subscribe"));
        oneTimeOption.addEventListener("click", () => updateSelection2("one-time"));

        itemRadios.forEach((radio) => {
            radio.addEventListener("change", function () {
                selectedRadioValue2 = radio.value;
                updateAllPricesAndTexts2(false);
                updateBuyNowLink2();
                updateSelectedOption2();
            });
        });
        
        optionContainers.forEach((container) => {
            container.addEventListener("click", function () {
                const radioButton = container.querySelector(".item-select-radio-2");
                if (radioButton) {
                    radioButton.checked = true;
                    selectedRadioValue2 = radioButton.value;
                    radioButton.dispatchEvent(new Event("change"));
                }
            });
        });

        window.addEventListener("resize", () => updateSelection2(isSubscribed2 ? "subscribe" : "one-time"));

        updateSelection2("subscribe");
        preselectFirstOption2();
    });

    updateCancelAnytimeSection2();
});

// Countdown Timer 3HOURS
function startCountdown() {
    const timerElement = document.querySelector('.second-product-timer');
    
    let totalSeconds = 3 * 60 * 60; 
    
    function updateTimer() {
        if (totalSeconds <= 0) {
            timerElement.textContent = "Expired";
            timerElement.style.color = "#FF6B6B";
            clearInterval(timerInterval);
            return;
        }
        
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        
        const formattedHours = String(hours).padStart(2, '0');
        const formattedMinutes = String(minutes).padStart(2, '0');
        const formattedSeconds = String(seconds).padStart(2, '0');
        
        timerElement.textContent = `${formattedHours}h: ${formattedMinutes}m: ${formattedSeconds}s`;
        
        totalSeconds--;
    }
    
    updateTimer();
    const timerInterval = setInterval(updateTimer, 1000);
}
document.addEventListener('DOMContentLoaded', startCountdown);

function startPromoCountdown() {
    const timerElement = document.querySelector('[data-id="promo-countdown"]');
    
    let totalSeconds = 10 * 60; 
    
    function updateTimer() {
        if (totalSeconds <= 0) {
            timerElement.textContent = "00:00";
            timerElement.style.color = "#FF6B6B";
            clearInterval(timerInterval);
            return;
        }
        
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        
        const formattedMinutes = String(minutes).padStart(2, '0');
        const formattedSeconds = String(seconds).padStart(2, '0');
        
        timerElement.textContent = `${formattedMinutes}:${formattedSeconds}`;
        
        totalSeconds--;
    }
    
    updateTimer();
    const timerInterval = setInterval(updateTimer, 1000);
}
document.addEventListener('DOMContentLoaded', startPromoCountdown);


// IMAGE CAROUSEL
var swiper = new Swiper('.mySwiper', {
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
});

// REVIEWS SWIPER
var reviewsSwiper = new Swiper(".reviews", {
    wrapperClass: "reviews-wrapper",
    slideClass: "reviews-slide",
    scrollbar: {
        el: ".reviews-scrollbar",
        hide: false,
        draggable: true,  // Allows dragging the scrollbar thumb
    },
    slidesPerView: 1,
    spaceBetween: 20,
});


// DROPDOWN MENUS
document.addEventListener('DOMContentLoaded', function() {
    const faqItems = document.querySelectorAll('.up-faq-container');
    
    function closeAllFaqs(exceptIndex = -1) {
        faqItems.forEach((item, index) => {
            if (exceptIndex !== index) {
                const answer = item.querySelector('.up-faq-answer');
                const plusIcon = item.querySelector('.up-faq-button img:first-child');
                const minusIcon = item.querySelector('.up-faq-button img:last-child');
                
                if (answer) answer.classList.add('hidden');
                if (plusIcon) plusIcon.classList.remove('hidden');
                if (minusIcon) minusIcon.classList.add('hidden');
            }
        });
    }
    
    faqItems.forEach((item, index) => {
        const questionButton = item.querySelector('.up-faq');
        if (!questionButton) return;
        
        questionButton.addEventListener('click', function(e) {
            e.stopPropagation();
            
            const answer = item.querySelector('.up-faq-answer');
            const plusIcon = item.querySelector('.up-faq-button img:first-child');
            const minusIcon = item.querySelector('.up-faq-button img:last-child');
            
     
            const isOpen = answer && !answer.classList.contains('hidden');
            
            if (isOpen) {
                answer.classList.add('hidden');
                if (plusIcon) plusIcon.classList.remove('hidden');
                if (minusIcon) minusIcon.classList.add('hidden');
            } else {
                closeAllFaqs(index);
                if (answer) answer.classList.remove('hidden');
                if (plusIcon) plusIcon.classList.add('hidden');
                if (minusIcon) minusIcon.classList.remove('hidden');
            }
        });
    });
});

// Suplement facts Popup

// Popup functionality

document.addEventListener('DOMContentLoaded', function() {
    const popupButtons = document.querySelectorAll('.popup-button');
    const popupOverlay = document.getElementById('supplementPopup');
    const closePopupMobile = document.getElementById('closePopupMobile');
    const closePopupDesktop = document.getElementById('closePopupDesktop');
    
    // Function to open popup
    function openPopup() {
        popupOverlay.classList.remove('hidden');
        popupOverlay.classList.add('show');
        document.body.style.overflow = 'hidden'; // Prevent background scrolling
    }
    
    // Function to close popup
    function closePopup() {
        popupOverlay.classList.add('hidden');
        popupOverlay.classList.remove('show');
        document.body.style.overflow = ''; // Restore scrolling
    }
    
    // Open popup when clicking popup button
    popupButtons.forEach(button => {
        button.addEventListener('click', openPopup);
    });
    
    // Close popup when clicking X buttons
    if (closePopupMobile) {
        closePopupMobile.addEventListener('click', closePopup);
    }
    
    if (closePopupDesktop) {
        closePopupDesktop.addEventListener('click', closePopup);
    }
    
    // Close when clicking outside the image (on overlay background)
    popupOverlay.addEventListener('click', function(e) {
        if (e.target === popupOverlay) {
            closePopup();
        }
    });
    
    // Close with Escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && popupOverlay && !popupOverlay.classList.contains('hidden')) {
            closePopup();
        }
    });
});

// Footer Links
document.addEventListener('DOMContentLoaded', function () {
    const linksContainer = document.querySelector('.footer-links');
    if (!linksContainer) return;

    // Function to update separators
    function updateSeparators() {
        const links = Array.from(linksContainer.querySelectorAll('a'))
            .filter(link => link.offsetParent !== null && !link.hidden); // Only visible links

        // Remove existing separators
        linksContainer.querySelectorAll('.separator').forEach(sep => sep.remove());

        // Insert separators only between visible links
        links.forEach((link, index) => {
            if (index < links.length - 1) {
                const separator = document.createElement('span');
                separator.textContent = ' | ';
                separator.classList.add('separator');
                linksContainer.insertBefore(separator, link.nextSibling);
            }
        });
    }

    // Initial call
    updateSeparators();

    // Poll every 100ms to check if new links are visible (e.g., due to TrueVault changes)
    const interval = setInterval(() => {
        // Run the update only if the state of the links changes
        if (linksContainer.querySelectorAll('a').length !== linksContainer.querySelectorAll('a:not([hidden])').length) {
            updateSeparators();
        }
    }, 100);

    // Clear the interval once it becomes redundant or the page is unloaded
    window.addEventListener('beforeunload', () => clearInterval(interval));
});


// Current year
document.querySelector('.current-year').textContent = new Date().getFullYear();


